import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from './Navbar';
import { DEFAULT_APP_LOCALE, isSupportedAppLocale, normalizeAppLocale } from '../lib/locales';
import { localizePathname } from '../lib/localeRouting';

const LoadingSpinner = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      <div
        style={{
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          animation: 'spin 1s linear infinite',
        }}
      />
      <div>{t('common.loading', { defaultValue: 'Loading...' })}</div>
    </div>
  );
};

export default function LocaleLayout() {
  const { locale } = useParams();
  const location = useLocation();
  const { i18n } = useTranslation();
  const normalizedLocale = normalizeAppLocale(locale);

  useEffect(() => {
    if (i18n.language !== normalizedLocale) {
      i18n.changeLanguage(normalizedLocale).catch((error) => {
        console.error('Failed to sync app locale from URL:', error);
      });
    }
  }, [i18n, normalizedLocale]);

  useEffect(() => {
    document.documentElement.lang = normalizedLocale;
  }, [normalizedLocale]);

  if (!isSupportedAppLocale(locale)) {
    return <Navigate to={localizePathname(location.pathname, DEFAULT_APP_LOCALE)} replace />;
  }

  return (
    <div className="App">
      <Navbar />
      <div className="app-shell-offset">
        <React.Suspense fallback={<LoadingSpinner />}>
          <Outlet />
        </React.Suspense>
      </div>
    </div>
  );
}
